import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=78c14de9"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"
import "./MaterialCard.vue?vue&type=style&index=0&id=78c14de9&prod&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports